// Each kind of tachograph exercise has its own set of endpoints under
// /tachograph/<kind>/. Exercise ids are one space across all kinds.
export const TACHOGRAPH_KINDS = ["manual-entry", "printout", "menu"] as const;

export type TachographKind = (typeof TACHOGRAPH_KINDS)[number];

export const isTachographKind = (value: unknown): value is TachographKind =>
  TACHOGRAPH_KINDS.includes(value as TachographKind);
